import { TrendChartKey, SetConsentPayloadType } from "../../slices/partner-program/Types";

export const partnerTierSagaActionTypes = {
  callPartnerTierListSaga: "callPartnerTierListSaga",
  callUpdatePartnerTierSaga: "callUpdatePartnerTierSaga",
  callDeletePartnerTierSaga: "callDeletePartnerTierSaga",
  callAddPartnerTiersSaga: "callAddPartnerTiersSaga",
  callPerformanceTrendSaga: "callPerformanceTrendSaga",
  callGetConsentStatusSaga: "callGetConsentStatusSaga",
  callSetConsentSaga: "callSetConsentSaga",
};

export const getPartnerTierListSagaAction: (ID: number) => {
  type: string;
  payload: {
    ID: number;
  };
} = (ID: number) => {
  return {
    type: partnerTierSagaActionTypes.callPartnerTierListSaga,
    payload: {
      ID: ID,
    },
  };
};

export type addPartnerTierListPayloadType = {
  ID: number;
  tier_name: string;
  min_points: number;
  max_points: number;
  short_description: string;
  long_description: string;
  created_at: string;
  update_at: string;
};

export const addPartnerTierSagaAction: (
  data: addPartnerTierListPayloadType
) => {
  type: string;
  payload: addPartnerTierListPayloadType;
} = (data: addPartnerTierListPayloadType) => {
  return {
    type: partnerTierSagaActionTypes.callAddPartnerTiersSaga,
    payload: data,
  };
};

export type updatePartnerTierListPayloadType = {
  ID: number;
  tier_name: string;
  min_points: number;
  max_points: number;
  short_description: string;
  long_description: string;
};

export const updatePartnerTierListSagaAction: (
  partnerTier: updatePartnerTierListPayloadType
) => {
  type: string;
  payload: {
    partnerTier: updatePartnerTierListPayloadType;
  };
} = (partnerTier: updatePartnerTierListPayloadType) => {
  return {
    type: partnerTierSagaActionTypes.callUpdatePartnerTierSaga,
    payload: {
      partnerTier: partnerTier,
    },
  };
};

export type deletePartnerTierListPayloadType = {
  ID: number;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};
export const deletePartnerTierList: (payload: deletePartnerTierListPayloadType) => {
  type: string;
  payload: {
    ID: number;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  };
} = (payload: deletePartnerTierListPayloadType) => {
  return {
    type: partnerTierSagaActionTypes.callDeletePartnerTierSaga,
    payload: payload,
  };
};

// Performance Trends
export type PerformanceTrendPayloadType = {
  chartKey: TrendChartKey;
  partnerId: number;
  range: string;
};

export const getPerformanceTrendSagaAction = (
  payload: PerformanceTrendPayloadType
) => {
  return {
    type: partnerTierSagaActionTypes.callPerformanceTrendSaga,
    payload,
  };
};

// Consent Actions
export const getConsentStatusSagaAction = (partnerId: number) => {
  return {
    type: partnerTierSagaActionTypes.callGetConsentStatusSaga,
    payload: { partnerId },
  };
};

export const setConsentSagaAction = (payload: SetConsentPayloadType) => {
  return {
    type: partnerTierSagaActionTypes.callSetConsentSaga,
    payload,
  };
};
